import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13455fb6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "priority-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseInput = _resolveComponent("BaseInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BaseInput, {
      id: _ctx.id,
      ref: "typeBox",
      value: _ctx.values.priority,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.values.priority) = $event)),
      type: "number",
      class: "priority-input",
      maxlength: "4",
      onBlur: _cache[1] || (_cache[1] = () => _ctx.updatePriority(_ctx.values.priority))
    }, null, 8, ["id", "value"])
  ]))
}